/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "2d960666cc6f09897562d001bca1389799923221";
